import { Info, AlertTriangle, AlertCircle } from 'lucide-react';

/**
 * Styles des types de commentaire / étape (couleurs Tailwind + hex pour canvas / SVG).
 * Source unique pour centre d’aide, lecteur, éditeur.
 */
export const COMMENT_STYLES = {
  info: {
    name: 'Info',
    color: 'bg-blue-500',
    borderColor: 'border-blue-500',
    textColor: 'text-blue-400',
    bgLight: 'bg-slate-800',
    icon: Info,
    hex: '#3b82f6',
  },
  attention: {
    name: 'Attention',
    color: 'bg-orange-500',
    borderColor: 'border-orange-500',
    textColor: 'text-orange-400',
    bgLight: 'bg-slate-800',
    icon: AlertTriangle,
    hex: '#f97316',
  },
  important: {
    name: 'Important',
    color: 'bg-red-500',
    borderColor: 'border-red-500',
    textColor: 'text-red-400',
    bgLight: 'bg-slate-800',
    icon: AlertCircle,
    hex: '#ef4444',
  },
};
